import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { useEffect, useState } from "react";
import SelectVMOnView,
{ bufferChangeHandler, clearLayerHandler, createSketchToolHandlers, drawGeometryHandler } from "./spatialSelectVM";

const useSpatialSelectVMinitialize = (props: any) => {

  const [sketchViewModel,setSketchViewModel] = useState()

  const [sketchEventHandlerList,setSketchEventHandlerList] = useState<any>([])
  const {
    attributeObject,
    selectDiv,
    pointDivBtnClk,
    lineDivBtnClk,
    polygonDivBtnClk,
    circleDivBtnClk,
    rectangleDivBtnClk,
    clearGeometryBtnClk,
    closeSpatialContainerBtnClk,
    view,
    bufferValue,
    setBufferValue,
    setShowQueryBlock
  } = props;

  useEffect(()=>{
    const bufferLayer = new GraphicsLayer({id:"bufferLayer", title:"buffer layer",listMode:"hide"})
    const sketchLayer = new GraphicsLayer({id:"sketchLayer", title:"sketch layer",listMode:"hide"})
    view.when((view)=>{
      view.map.addMany([bufferLayer,sketchLayer])
    })
  },[view])

  useEffect(()=>{
    if(sketchViewModel!==undefined){
      if(sketchEventHandlerList.length>0){
        sketchEventHandlerList.forEach(handle=>handle.remove())
      }
      setSketchEventHandlerList(createSketchToolHandlers(view,sketchViewModel,attributeObject,bufferValue))
    if (pointDivBtnClk.current) {
      pointDivBtnClk.current.onclick=(e)=>{
        e.preventDefault()
        drawGeometryHandler(e,view,sketchViewModel) 
      }
    }
    if (lineDivBtnClk.current) {
      lineDivBtnClk.current.onclick=(e)=>{
        e.preventDefault()
        drawGeometryHandler(e,view,sketchViewModel)}
    }
    if (polygonDivBtnClk.current) {
      polygonDivBtnClk.current.onclick=(e)=>{
        e.preventDefault()
        drawGeometryHandler(e,view,sketchViewModel,'hybrid');
      }
    }
    if (circleDivBtnClk.current) {
      circleDivBtnClk.current.onclick=(e)=>{
        e.preventDefault()
        drawGeometryHandler(e,view,sketchViewModel)
      }
    }
    if (rectangleDivBtnClk.current) {
      rectangleDivBtnClk.current.onclick=(e)=>{
        e.preventDefault()
        drawGeometryHandler(e, view, sketchViewModel)
      }
    }
  }
},[view,sketchViewModel,attributeObject,
  bufferValue,pointDivBtnClk,lineDivBtnClk,polygonDivBtnClk,
  circleDivBtnClk,rectangleDivBtnClk])

useEffect(()=>{
  bufferChangeHandler(bufferValue,view,attributeObject)
},[bufferValue,view,attributeObject])

  useEffect(() => {
    try {
      if (selectDiv.current) {
        SelectVMOnView(view).then((model) => {
          if (clearGeometryBtnClk.current) {
            clearGeometryBtnClk.current.onclick =
              model.clearLayerHandler;
          }
          setSketchViewModel(model.sketchViewModel);
        });
      }
    } catch (e) {
      console.error(e);
    }

    return () => {

    };
  }, [selectDiv,clearGeometryBtnClk]);

  useEffect(() => {
    try {
      if (selectDiv.current) {
          if (closeSpatialContainerBtnClk.current) {
            closeSpatialContainerBtnClk.current.onclick =
            ()=>{
              clearLayerHandler(view,sketchViewModel);
              setShowQueryBlock(false);
              setBufferValue(0);
            }
          }
      }
    } catch (e) {
      console.error(e);
    }

    return () => {

    };
  }, [selectDiv,closeSpatialContainerBtnClk,setBufferValue,view,setShowQueryBlock,sketchViewModel]);
};
export default useSpatialSelectVMinitialize;
